import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Safely format numbers to avoid NaN/Infinity
export function safeNumber(value: number | undefined | null, fallback: number = 0): number {
  if (value === undefined || value === null || !isFinite(value) || isNaN(value)) {
    return fallback;
  }
  return value;
}

// Safely divide with fallback
export function safeDivide(numerator: number, denominator: number, fallback: number = 0): number {
  if (denominator === 0 || !isFinite(denominator) || isNaN(denominator)) {
    return fallback;
  }
  const result = numerator / denominator;
  return isFinite(result) && !isNaN(result) ? result : fallback;
}

// Safely format percentage
export function safePercentage(numerator: number, denominator: number, decimals: number = 1): string {
  const value = safeDivide(numerator, denominator, 0) * 100;
  return value.toFixed(decimals);
}

// Normalize URL to include https:// protocol
export function normalizeUrl(url: string): string {
  if (!url || url.trim() === '') return '';
  
  // Remove whitespace
  const trimmed = url.trim();
  
  // If already has protocol, return as is
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }
  
  // Add https:// prefix
  return `https://${trimmed}`;
}
